import { Component, ViewEncapsulation } from '@angular/core';
import { SystemMessages } from '@portal-core/system-messages/components/system-messages';
import { NgFor, AsyncPipe } from '@angular/common';
import { SystemMessageCardComponent } from '@portal-core/system-messages/components/system-message-card/system-message-card.component';

@Component({
    selector: 'mc-system-message-cards',
    templateUrl: './system-message-cards.component.html',
    styleUrls: ['./system-message-cards.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgFor, SystemMessageCardComponent, AsyncPipe]
})
export class SystemMessageCardsComponent extends SystemMessages {
}
